import { render, staticRenderFns } from "./HistoricalAccessControl.vue?vue&type=template&id=44391d49&"
import script from "./HistoricalAccessControl.vue?vue&type=script&lang=js&"
export * from "./HistoricalAccessControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports